module.exports = __webpack_public_path__ + "media/giff 4.fb4bef1e.mp4";